"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ComparisonSelector;
exports.getComparisonOptions = getComparisonOptions;
exports.isBetween = isBetween;
exports.isSelect = isSelect;
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _architectureTypes = require("../types/architectureTypes");
var _visualTypes = require("../types/visualTypes");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  iconStyle: {
    color: theme.palette.text.primary
  }
}));
function ComparisonSelector({
  semanticType,
  isAggregate,
  onChange,
  ...rest
}) {
  const classes = useStyles();
  function handleChange(e) {
    const operator = e.target.value;
    onChange(operator);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
    fullWidth: true,
    select: true,
    onChange: handleChange,
    ...rest,
    sx: theme => ({
      '& .MuiInput-underline::before': {
        borderBottomColor: theme.palette.text.primary
      }
    }),
    SelectProps: {
      classes: {
        icon: classes.iconStyle
      }
    },
    children: semanticType ? getComparisonOptions(semanticType, isAggregate).map(c => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        value: c.value,
        children: c.label
      }, c.value);
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      children: "NA"
    })
  });
}
function getComparisonOptions(semanticType, isAggregate) {
  const {
    type,
    baseDataType
  } = semanticType;
  let options = [];
  if (type === _architectureTypes.PropertyType.QUANTITATIVE || baseDataType === 'Date') {
    options = options.concat([{
      value: _visualTypes.ComparisonOperator.EQUAL,
      label: 'Equal'
    }, {
      value: _visualTypes.ComparisonOperator.NOT_EQUAL,
      label: 'Not Equal'
    }, {
      value: _visualTypes.ComparisonOperator.LESS_THAN,
      label: 'Less Than'
    }, {
      value: _visualTypes.ComparisonOperator.LESS_THAN_OR_EQUAL,
      label: 'Less than or Equal to'
    }, {
      value: _visualTypes.ComparisonOperator.GREATER_THAN,
      label: 'Greater Than'
    }, {
      value: _visualTypes.ComparisonOperator.GREATER_THAN_OR_EQUAL,
      label: 'Greater than or Equal to'
    }, {
      value: _visualTypes.ComparisonOperator.BETWEEN,
      label: 'Between'
    }]);
  } else if (!isAggregate) {
    options = options.concat([{
      value: _visualTypes.ComparisonOperator.IN,
      label: 'In'
    }, {
      value: _visualTypes.ComparisonOperator.NOT_IN,
      label: 'Not In'
    }]);
  }
  if (type === _architectureTypes.PropertyType.DEFINING) {
    options = options.concat([{
      value: _visualTypes.ComparisonOperator.EQUAL,
      label: 'Equal'
    }, {
      value: _visualTypes.ComparisonOperator.NOT_EQUAL,
      label: 'Not Equal'
    }, {
      value: _visualTypes.ComparisonOperator.LESS_THAN,
      label: 'Less Than'
    }, {
      value: _visualTypes.ComparisonOperator.LESS_THAN_OR_EQUAL,
      label: 'Less than or Equal to'
    }, {
      value: _visualTypes.ComparisonOperator.GREATER_THAN,
      label: 'Greater Than'
    }, {
      value: _visualTypes.ComparisonOperator.GREATER_THAN_OR_EQUAL,
      label: 'Greater than or Equal to'
    }, {
      value: _visualTypes.ComparisonOperator.BETWEEN,
      label: 'Between'
    }]);
  }
  if (!isAggregate) options = options.concat([{
    value: _visualTypes.ComparisonOperator.CONTAINS,
    label: 'Contains'
  }, {
    value: _visualTypes.ComparisonOperator.NOT_CONTAINS,
    label: 'Not Contains'
  }, {
    value: _visualTypes.ComparisonOperator.STARTS_WITH,
    label: 'Starts With'
  }, {
    value: _visualTypes.ComparisonOperator.ENDS_WITH,
    label: 'Ends With'
  }, {
    value: _visualTypes.ComparisonOperator.BETWEEN,
    label: 'Between'
  }, {
    value: _visualTypes.ComparisonOperator.NOT_BETWEEN,
    label: 'Not Between'
  }]);
  return options;
}
function isSelect(comparison) {
  return comparison === _visualTypes.ComparisonOperator.IN || comparison === _visualTypes.ComparisonOperator.NOT_IN;
}
function isBetween(comparison) {
  return comparison === _visualTypes.ComparisonOperator.BETWEEN || comparison === _visualTypes.ComparisonOperator.NOT_BETWEEN;
}